export const coClass = { 0: 'success-color', 1: 'warning-color', 2: 'danger-color' };

export const getO2IconClass = makeFu({ key: 'ecMod', sensor: 'o2' }, function (wsData) {
  const { mods } = wsData || {};
  const sensorData = (mods && mods[this.key] && mods[this.key][this.sensor]) || {};
  const { alarmState } = sensorData;
  if (!alarmState && alarmState !== 0) return;
  return coClass[alarmState] || '';
});

function makeFu(params, fn) {
  params.fn = fn;
  return function (...args) {
    return params.fn(...args);
  };
}

/**
 * 传入状态数组 按照优先级返回状态'上升', '下降', '平稳'
 * 传入空返回平稳
 * @param {Array<String>} states ['上升', '下降', '平稳']
 */
export function ecModTrend(states) {
  const weight = ['上升', '下降', '平稳'];
  const res = states.filter(e => weight.includes(e));
  if (!res.length) return weight[2];
  return weight.find(e => res.join(',').indexOf(e) !== -1);
}

/**
 * 传入状态数组 按优先级返回其中一个状态
 * @param {*} states
 */
export function ecModRunState(states) {
  // 顺序为非正常状态优先
  const weight = ['3', '2', '4', '-1', '1'];
  const res = states.filter(e => weight.includes(`${e}`));
  if (!res.length) return undefined;
  return +weight.find(e => res.includes(+e));
}

/**
 * 传入状态数组 按优先级返回其中一个状态
 * @param {*} states
 */
export function ecModDeviceState(...mods) {
  const res = mods.find(e => e.alarmState > 0);
  return res ? 2 : 0;
}

export function extECModAlarmName(...mods) {
  const res = mods.filter(e => e.alarmState > 0);
  return res.map(e => e.name).join(',') || '无';
}

export function extSensorValAndUnitToText(mod, sensorNameList, config) {
  const { sep, valueProp, unitProp, sameUnit, hasWrap, defUnit, customUnitDict } = Object.assign(
    {
      sep: '/',
      valueProp: 'value',
      unitProp: 'unitName',
      hasWrap: true,
      defUnit: '',
      customUnitDict: {},
      sameUnit: true
    },
    config
  );

  const text = sensorNameList
    .map(name => {
      const v = mod[name][valueProp];

      if (sameUnit) {
        return v;
      } else {
        const unit = customUnitDict[name] || mod[name][unitProp];

        const unitAndWrap = hasWrap ? `(${unit})` : unit;

        return `${v}${unitAndWrap}`;
      }
    })
    .join(sep);

  if (sameUnit) {
    const unit = defUnit || mod[sensorNameList[0]][unitProp];

    const unitAndWrap = hasWrap ? `(${unit})` : unit;

    return `${text}${unitAndWrap}`;
  }

  return text;
}
